import { gsap } from "gsap";
import { Power0 } from 'gsap/all';
import ScrollMagic from 'scrollmagic';

export default class Anim8_announcements {

	constructor(scroll, sceneFactory, controller, domElem) {

		if( !domElem ) {
			console.error('DOM ELEMENT FOR ANNOUNCEMENTS NOT FOUND');
			return;
		}

		this.animatedIn = false;
		this.animatedOut = false;

		this.useScrollTrigger = true;

		this.domElem = domElem;
		this.sceneElemName = this.domElem.getAttribute('data-anchor').toLowerCase();
        this.sceneDuration = this.domElem.getAttribute('data-duration');
        this.sceneOffset = this.domElem.getAttribute('data-offset');

		this.dimensions = domElem.getBoundingClientRect();
		this.domCards = domElem.querySelectorAll('.announcement-card');

		if( !this.domCards ||  this.domCards.length < 0 ) {
			console.error('DOM CARD ANNOUNCEMENTS NOT FOUND');
			return;
		}

		this.initTimeline();

		if( ![undefined,null].includes(scroll) && ![undefined,null].includes(controller) ) {
			this.initScrollMagic(scroll, sceneFactory, controller);
		} else {
			//this.defaultTween();
		}

		console.warn("[Anim8_announcements.js] loaded");
		
		return this.timeline;
	}

	initTimeline() {

		this.timeline = gsap.timeline({
			delay: 0,
			defaults: {
				ease: "power1.inOut"
			},
			scrollTrigger: (this.useScrollTrigger === true ? this.scrollTriggerOptions() : false),
			onComplete: () => {
				console.log("Anim8_announcements.js finished");
			},
		});
	}

	scrollTriggerOptions() {

		const announcementBadges = this.domElem.querySelectorAll('.announcement-badge');

		if( announcementBadges && announcementBadges.length > 0 ) {
			for (let index = 0; index < announcementBadges.length; index++) {
				const aB = announcementBadges[index];
				aB.style.opacity = 0;
			}
		}

		return {
			trigger: this.domElem,
			pin: false, // pin the trigger element while active
			start: 'top bottom', // when the top of the trigger hits the top of the viewport
			end: `+=${this.dimensions.height*.75}`,
			//end: '+=500', // end after scrolling 500px beyond the start
			//end: 'top bottom',
			//toggleActions: "play none none reset",
			scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
			//markers: {startColor:"green", endColor:"red", fontSize:"12px"},
			//onToggle: self => console.log(`${this.sceneElemName} active:`, self.isActive),
			onEnter: (({progress, direction, isActive}) =>{
				gsap.fromTo(
					this.domElem.querySelectorAll('.announcement-card'), 
					{
						autoAlpha: 0,
						scale: .5,
					},
					{
						autoAlpha: 1,
						scale: 1,
						stagger: .1,
						overwrite: false,
						//ease: "power1.inOut"
						//immediateRender: false,
						//ease: Power0.easeInOut
						ease: Power0.easeOut,
						onComplete: ((e)=>{
							//console.log('ALL CASE STUDIES ANIMATION COMPLETE', e);

							if( announcementBadges && announcementBadges.length > 0 ) {
								gsap.fromTo(
									announcementBadges, 
									{
										autoAlpha: 0,
										//scale: .5,
									},
									{
										autoAlpha: 1,
										//scale: 1,
										stagger: .1,
										overwrite: false,
										//ease: "power1.inOut"
										//immediateRender: false,
										//ease: Power0.easeInOut
										ease: Power0.easeOut,
									}
								);
							}

							/** /
							this.domCards.forEach((elem)=>{
								if( elem.classList.contains('animate-kensburn') ) {

								} else {
									elem.classList.add('animate-kensburn');
								}
							})
							/**/
						}),
						onLeaveBack: (({progress, direction, isActive}) =>{
							if( announcementBadges && announcementBadges.length > 0 ) {
								for (let index = 0; index < announcementBadges.length; index++) {
									const aB = announcementBadges[index];
									aB.style.opacity = 0;
								}
							}
						})
					}
				)
			})
		}

	}

	initScrollMagic(scroll, sceneFactory, controller) {
	
		this.scrollMagicScene = new ScrollMagic.Scene({
			triggerElement: this.domElem,
			duration: this.sceneDuration,
			offset:  this.dimensions.height/2,
			triggerHook: 'onEnter'
		})
		.addTo(controller)
		.setClassToggle( this.domElem, 'active');

		scroll.options.scenes.push(this.scrollMagicScene);

		this.scrollMagicScene.on('enter', (e) => {
			//this.animateCardsIn();
		});

		this.scrollMagicScene.on('leave', (e) => {
			//this.animateCardsOut();
		});	
	}

	defaultTween() {

        //console.log('CTA:', this.domElem.querySelector('.custom-call-to-action'));

        return this.timeline
        .fromTo(
			this.domElem.querySelectorAll('.announcement-card'), 
			{
				autoAlpha: 0,
				scale: .5,
			},
			{
				autoAlpha: 1,
				scale: 1,
				stagger: .1,
				overwrite: false,
				ease: "power1.inOut"
				//immediateRender: false,
				//ease: Power0.easeInOut
				//ease: Power0.easeOut
			}
		)
		//announcement-badge
		
	}

	/**
	 * CARDS ANIMATION
	 * /
	animateCardsIn() {

		this.domCards.forEach((elem)=>{
			if( !elem.classList.contains('show') ) {
				elem.classList.add('show');
			}

			if( elem.classList.contains('blur-out') ) {
				elem.classList.remove('blur-out');
			}
			
		})

	}

	animateCardsOut() {

		this.domCards.forEach((elem)=>{
			if( elem.classList.contains('show') ) {
				if( document.body.classList.contains('scroll-up') ) {
					elem.classList.remove('show');
				}
			}

			if( elem.classList.contains('blur-out') ) {
				if( document.body.classList.contains('scroll-up') ) {
					elem.classList.remove('blur-out');
				}
			}
			
		})
	}
	/**/

}
